import { coreApiRoutes } from '../../core/config/api/apiRoutes';
import { erpApiRoutes } from '../../erp/config/api/apiRoutes';

export const apiRoutes = {
  ...coreApiRoutes,
  ...erpApiRoutes,
};
